import { ToggleButton, type ToggleButtonProps } from 'primereact/togglebutton';
import { classNames } from 'primereact/utils';
import './travel-customization.styles.css';

const DayButton = (props: ToggleButtonProps) => {
	return (
		<ToggleButton
			{...props}
			pt={{
				box: (e) => ({
					className: classNames(
						{
							'tc-day-button-off': !e?.props.checked,
							'secondary tc-day-button-on': e?.props.checked,
						},
						props.pt?.box,
					),
				}),
			}}
		/>
	);
};

export default DayButton;
